export const ActivityStatus = Object.freeze({
  due: 0,
  dismissed: 1,
  completed: 2,
  hidden: 3,
});

export const ActivityStatusLabel = Object.freeze({
  [ActivityStatus.due]: 'Due',
  [ActivityStatus.dismissed]: 'Dismissed',
  [ActivityStatus.completed]: 'Completed',
  [ActivityStatus.hidden]: 'Hidden',
});

export function isValid(type) {
  return Object.values(ActivityStatus).find((elem) => elem === type);
}

export function toLabel(type) {
  return ActivityStatusLabel[type];
}
